export default {
  api: {
    baseUrl: 'https://api.mari.chat',
    chatUrl: 'https://api.channel.mari.chat',
    backOfficeUrl: 'https://api.mari.chat',
  },
};
